<template>
  <v-layout class="catalog grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
      <div class="d-flex justify-end align-center">

        <v-text-field
          v-model="search"
          label="Busca productos"
          solo
          hide-details
          rounded
          flat
          dense
          clearable
          @click:clear="load()"
        >
          <template v-slot:append>
            <v-menu
              bottom
              :offset-y="true"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="!search"
                  color="primary"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item dense>
                  <v-btn color="primary" text @click="searchProducts(typeSearch = 'name')">Buscar por nombre de producto</v-btn>
                </v-list-item>
                <v-list-item dense>
                  <v-btn color="primary" text @click="searchProducts(typeSearch = 'aliasesProvider')">Buscar por nombre en factura</v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-text-field>
      </div>
      <div
        v-if="productsCatalogPermissions['create-product']"
        class="ml-3">
        <v-btn
          data-cy="addProduct"
          fab
          x-small
          depressed
          color="primary"
          @click="openCreateProductDialog"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
      <div class="ml-3">
        <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                data-cy="addProduct"
                fab
                x-small
                depressed
                color="secondary"
                @click="goToVariantsDuplicates"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>
              Buscar variantes duplicadas
            </span>
          </v-tooltip>
      </div>
      <div
        v-if="productsCatalogPermissions['upload-invoice']"
        class="ml-3">
        <v-btn
          color="primary"
          rounded
          small
          depressed
          @click="openUploadInvoiceDialog">
          Subir factura
        </v-btn>
      </div>
      <div class="ml-3">
        <v-btn
          rounded
          small
          depressed
          color="primary"
          class="white--text mr-3"
          @click="exportCatalogToCSV"
          >
          Exportar catálogo como CSV
        </v-btn>
      </div>
    </div>

    <CreateProduct ref="createProduct" @update="load()"/>

    <EditVariant :variant="variant" ref="editVariant" @update="searchProducts(typeSearch)" />

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [100, 300, 500]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col md="3">
                <div class="d-flex align-end">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-select
                    v-model="statusSelected"
                    :items="statuses"
                    item-value="value"
                    item-text="text"
                    label="Estatus"
                    hide-details
                    return-object
                    dense
                    @change="filterProducts"
                  />
                </div>
              </v-col>
              <v-col md="3">
                <div class="d-flex align-end">
                  <v-select
                    v-model="category"
                    :items="categories"
                    item-value="id"
                    item-text="name"
                    label="Departamento"
                    hide-details
                    return-object
                    dense
                    @change="filterProducts"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.satCode="{ item }">
          <div v-if="item.satCode">
            {{ item.satCode }}
            <v-btn
              v-if="item.status === 'pending'"
              icon
              rounded
              x-small
              depressed
              color="primary"
              @click="openSatCodeDialog(item)">
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              outlined
              rounded
              x-small
              depressed
              color="primary"
              @click="openSatCodeDialog(item)">
              {{ $t('products.modals.addSatCode.title') }}
            </v-btn>
          </div>
        </template>
        <template v-slot:item.product="{ item }">
          <a href="#" @click.prevent="openDetail(item)">{{((item.product || {}).name || '')}}</a>
        </template>
        <template v-slot:item.category="{ item }">
          {{ item.product && item.product.category ? item.product.category.name : 'Sin departamento' }}
        </template>
        <template v-slot:item.quantity="{ item }">
          <div style="min-width: 170px">
            <v-text-field
              outlined
              rounded
              hide-details
              v-model="item.quantity"
              type="number"
              :suffix="`${item.displayUnit.name.slice(0, 5)}...`"
              @input="updateWarehouseQuantity($event, item)"
            />
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <div v-if="item.status !== 'pending'">
            <v-tooltip
            top
            max-width="300">
            <template v-slot:activator="{ on }">
              <v-btn x-small icon v-on="on">
                <v-icon color="dark-grey">mdi-information</v-icon>
              </v-btn>
            </template>
            <span>
              {{ statusDescriptions(item.status) }}
            </span>
          </v-tooltip>
          <span>
            {{ statuses.find(status => status.value === item.status).text }}
          </span>
          </div>
          <div v-else>
            <v-btn
              x-small
              outlined
              rounded
              color="primary"
              @click="openInReviewDialog(item)">
              Enviar a revisión
            </v-btn>
          </div>
        </template>
        <template v-slot:item.displayQuantity="{ item }">
          <div v-if="(item.displayUnit && item.displayUnit.name) && (item.contentUnit && item.contentUnit.name)">
            {{ item.displayQuantity }} {{ item.displayUnit.name }} de {{ item.contentQuantity }}  {{ item.contentUnit.name }}
          </div>
          <div v-else>
            {{ item.displayQuantity }} {{ findUnit(item.displayUnit) }} de {{ item.contentQuantity }} {{ findUnit(item.contentUnit) }}
          </div>
        </template>
        <template v-slot:item.amount="{ item }">
          <div class="mb-2">
            {{ calculatePriceProductWithTaxes(item) | toFixNumber(2) | numberWithComma | prefix('$') }}
          </div>
        </template>
        <template v-slot:item.type="{ item }">
          <div class="mb-2">
            <span v-if="!item.product">
              Sin categoría
            </span>
            <span v-else>
              {{ productType(item.product.type) }}
            </span>
          </div>
        </template>
        <template v-slot:item.brand="{ item }">
          {{ item.brand ? item.brand.toUpperCase() : '-' }}
        </template>
        <template v-slot:item.description="{ item }">
          <div v-if="item.description">
            {{ item.description | truncateText(25) }}
            <v-tooltip top max-width="300">
              <template v-slot:activator="{ on }">
                <v-btn x-small icon v-on="on">
                  <v-icon color="dark-grey">mdi-information</v-icon>
                </v-btn>
              </template>
              <span>
                {{ item.description }}
              </span>
            </v-tooltip>
          </div>
          <div v-else></div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  x-small
                  fab
                  depressed
                  v-on="on"
                  class="mr-1"
                  color="accent"
                >
                  <v-icon>
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="openSearchPucharseOrdersDialog(item)">
                  <v-list-item-icon>
                    <v-icon color="secondary">
                      mdi-magnify
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    Buscar ordenes compra
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="productsCatalogPermissions['edit-product']" @click="openEditVariant(item)">
                  <v-list-item-icon>
                    <v-icon color="primary">
                      mdi-border-color
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    Editar producto
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteProduct(item)">
                  <v-list-item-icon>
                    <v-icon color="error">
                      mdi-delete
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    Eliminar producto
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <TaxesPanel
      :product="selectedProduct"
      :isOpen="isPanelOpen"
      @closed="closePanel"
      @updated="updateTaxes"/>

    <v-dialog @keydown.esc="addSatCodeDialog=false" v-model="addSatCodeDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('products.modals.addSatCode.title') }}</span>
        </v-card-title>
        <v-card-text>
          <div>
             {{ selectedProduct.product ? selectedProduct.product.name : '' }}
          </div>
          <div class="py-3">
            <v-form ref="form" v-model="form.valid">
              <v-text-field
                data-cy="satCode"
                v-model="form.data.satCode"
                required
                rounded
                outlined
                dense
                :rules="rules.satCode"
                :label="$t('products.labels.satCode')"/>
            </v-form>
          </div>
          <v-divider/>
          <div class="pt-3">
            Si no sabes qué CLAVE debes designar al producto consulta la guía del SAT aquí:
          </div>
          <div>
            <a href="http://pys.sat.gob.mx/PyS/catPyS.aspx" target="_blank" rel="noopener noreferrer">
              Catálogo de Productos y Servicios del SAT
            </a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeSatCodeDetail">
            {{ $t('products.modals.addSatCode.cancelAction') }}
          </v-btn>
          <v-btn
            data-cy="successAction"
            color="primary"
            rounded
            small
            depressed
            @click="addSatCode">
            {{ $t('products.modals.addSatCode.successAction') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="inReviewDialog=false" v-model="inReviewDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Envia a revisión</span>
        </v-card-title>
        <v-card-text>
          <div class="pb-3">
            ¿Quieres enviar a "Revisión" el producto: <br>
            <b>{{ selectedProduct.product ? selectedProduct.product.name : '' }}</b>?
          </div>
          <v-divider/>
          <div class="pt-3">
            En eato revisaremos los datos del producto y si nos surge alguna duda te contactaremos.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeInReviewDialog">
            {{ $t('messages.no') }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="sendToInReview">
            {{ $t('messages.yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="deleteDialog=false"
      v-model="deleteDialog"
      max-width="400"
      >
      <v-card>
        <v-card-title>
          ¿Estás seguro que deseas eliminar el producto {{ variant.product ? variant.product.name : '' }} ?
        </v-card-title>
        <v-card-text>
          ¡Cuidado!<br>
          {{ errorMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeDeleteDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="forceDeleteProduct">
            De acuerdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SearchPucharseOrders ref="searchPucharseOrdersDialog" :product="product" />

    <DetailProduct ref="detail" :product="selectedProduct" />

    <UploadProductsByXML ref="uploadByXML" @updated="load()" />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import TaxesPanel from '@/components/sidePanels/Taxes'
import UploadProductsByXML from '@/components/modals/UploadProductsByXML'
import SearchPucharseOrders from '@/components/modals/SearchPucharseOrders'
import CreateProduct from '@/components/modals/CreateProduct'
import EditVariant from '@/components/modals/EditVariant'
import DetailProduct from '@/components/sidePanels/DetailProduct'
import debounce from 'lodash/debounce'
import Papa from 'papaparse'

export default {
  name: 'ProductsCatalog',
  components: {
    TaxesPanel,
    CreateProduct,
    EditVariant,
    UploadProductsByXML,
    DetailProduct,
    SearchPucharseOrders
  },
  data () {
    return {
      overlay: false,
      isPanelOpen: false,
      addSatCodeDialog: false,
      inReviewDialog: false,
      deleteDialog: false,
      section: this.$i18n.t('products.section'),
      table: {
        title: this.$i18n.t('products.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('products.headers.satCode'), value: 'satCode' },
          { text: this.$i18n.t('products.headers.name'), value: 'product' },
          { text: 'Marca', value: 'brand', sortable: false },
          { text: this.$i18n.t('products.headers.departament'), value: 'category', sortable: false },
          { text: this.$i18n.t('products.headers.displayQuantity'), value: 'displayQuantity', sortable: false },
          { text: this.$i18n.t('products.headers.price'), value: 'amount', sortable: false },
          { text: this.$i18n.t('products.headers.description'), value: 'description', sortable: false },
          // { text: this.$i18n.t('products.headers.warehouseQuantity'), value: 'quantity' },
          { text: this.$i18n.t('products.headers.status'), value: 'status' },
          { text: this.$i18n.t('products.headers.productType'), value: 'type', sortable: false },
          { text: this.$i18n.t('products.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 100,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      search: '',
      selectedProduct: {},
      form: {
        valid: false,
        data: {
          satCode: ''
        }
      },
      rules: {
        satCode: [
          v => !!v || this.$t('validations.satCode.required'),
          v => /^\d+$/.test(v) || this.$t('validations.satCode.valid')
        ]
      },
      statuses: [
        { value: '', text: 'Todas' },
        { value: 'pending', text: 'Pendiente', color: 'grey' },
        { value: 'approved', text: 'Aprobado', color: 'grey' },
        { value: 'in-review', text: 'En revisión', color: 'secondary' },
        { value: 'published', text: 'Publicado para venta', color: 'primary' }
      ],
      statusSelected: { value: '', text: 'Todas' },
      category: { id: '', name: 'Todas' },
      variant: {},
      errorMessage: '',
      typeSearch: '',
      product: {}
    }
  },
  computed: {
    categories () {
      const categories = [...this.$store.state.categories]
      categories.unshift({ id: '', name: 'Todas' })
      return categories
    },
    productsCatalogPermissions () {
      return this.$store.state.login.permissions['products-catalog'].components['products-catalog-list'].actions
    }
  },
  // watch: {
  //   'search': debounce(async function (val) {
  //     if (val.length === 0) {
  //       try {
  //         this.table.options.page = 1
  //         const params = {
  //           limit: this.table.options.itemsPerPage,
  //           skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
  //           sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
  //           status: this.statusSelected.value,
  //           category: this.category.id
  //         }
  //         if (val) params.name = val
  //         await this.load(params)
  //       } catch (error) {
  //         this.$toasted.show(error.message, { duration: 3000 })
  //       }
  //     }
  //   }, 600)
  // },
  async mounted () {
    await this.$store.dispatch('getCategories')
  },
  methods: {
    calculatePriceProductWithTaxes (product) {
      let priceWithTaxes = product.amount
      let totalTaxes = 0
      if (product.taxes) {
        const ieps = product.taxes.find(tax => tax.satCode === '003')
        const iva = product.taxes.find(tax => tax.satCode === '002')

        const otherTaxes = product.taxes
          .filter(tax => !['003', '002'].includes(tax.satCode))

        if (ieps) {
          priceWithTaxes = priceWithTaxes + ieps.base
        }

        totalTaxes = otherTaxes.reduce((acc, num) => {
          let taxApplied
          if (num.isQuota) {
            taxApplied = num.base
          } else {
            taxApplied = (num.base / 100) * product.amount
          }
          acc += taxApplied
          return acc
        }, 0)

        if (iva) {
          priceWithTaxes = priceWithTaxes + (priceWithTaxes * (iva.base / 100))
        }

        priceWithTaxes = totalTaxes + priceWithTaxes

        return priceWithTaxes
      } else {
        return priceWithTaxes
      }
    },
    openSearchPucharseOrdersDialog (item) {
      this.product = item
      this.$refs.searchPucharseOrdersDialog.open()
    },
    async searchProducts (typeSearch) {
      if (this.search.length > 3) {
        this.table.loading = true
        try {
          this.table.options.page = 1
          const params = {
            typeSearch,
            value: this.search,
            provider: this.$store.state.currentProvider.data._id
          }

          const response = await this.$api.get('/v1/search/catalog', params)
          this.table.data = response.data
          this.table.total = response.total
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.table.loading = false
      } else {
        await this.load()
      }
    },
    statusDescriptions (status) {
      return {
        approved: 'El producto ha sido aprobado para la venta.',
        'in-review': 'El producto esta siendo revisado.',
        published: 'El producto se encuentra disponible para la venta.'
      }[status]
    },
    updateWarehouseQuantity: debounce(async function (val, product) {
      this.overlay = true
      try {
        const payload = {
          status: product.status,
          quantity: Number(val) || 0
        }
        await this.$api.put(`/v1/catalog/${product.id}`, payload)
        this.$toasted.show('El inventario se actualizó correctamente', { duration: 1000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }, 800),
    openDetail (item) {
      this.selectedProduct = item
      this.$refs.detail.open()
    },
    filterProducts: async function () {
      this.table.options.page = 1
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
        status: this.statusSelected.value,
        category: this.category.id
      }
      await this.load(params)
    },
    sendToInReview: async function () {
      this.overlay = true
      try {
        await this.$api.put(`/v1/catalog/${this.selectedProduct._id}`, { status: 'in-review' })
        this.closeInReviewDialog()
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openInReviewDialog (item) {
      this.selectedProduct = item
      this.inReviewDialog = true
    },
    closeInReviewDialog (item) {
      this.selectedProduct = {}
      this.inReviewDialog = false
    },
    getTaxName (taxes) {
      if (taxes.length) {
        return taxes.map(tax => tax.name)
      }
      return 'Sin impuestos'
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      this.table.options = data
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`,
        status: this.statusSelected.value,
        category: this.category.id
      })
    },
    async load (params = null) {
      this.typeSearch = null
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
        status: this.statusSelected.value,
        category: this.category.id
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/catalog`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    openSatCodeDialog (item) {
      this.selectedProduct = item
      this.addSatCodeDialog = true
    },
    addSatCode: async function () {
      if (this.form.valid) {
        this.overlay = true
        try {
          const payload = {
            satCode: this.form.data.satCode,
            status: this.selectedProduct.status
          }
          await this.$api.put(`/v1/catalog/${this.selectedProduct._id}`, payload)
          this.closeSatCodeDetail()
          await this.load()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    closeSatCodeDetail () {
      if (this.$refs.form) this.$refs.form.reset()

      this.selectedProduct = {}
      this.addSatCodeDialog = false
    },
    openProductDetail (item) {
      this.selectedProduct = item
      this.isPanelOpen = true
    },
    closePanel () {
      this.isPanelOpen = false
    },
    updateTaxes: async function (item) {
      this.selectedProduct = item
      await this.load()
    },
    openCreateProductDialog () {
      this.$refs.createProduct.open()
    },
    openEditVariant (variant) {
      this.variant = variant
      this.$refs.editVariant.open()
    },
    openDeleteVariant (variant) {
      this.variant = variant
      this.deleteDialog = true
    },
    closeDeleteDialog () {
      this.variant = {}
      this.deleteDialog = false
    },
    async deleteProduct (item) {
      this.overlay = true
      const variant = item
      try {
        await this.$api.del(`/v1/catalog/${variant._id}`)
        this.$toasted.show('El producto se eliminó correctamente', { duration: 3000 })
        if (!this.search) {
          await this.load()
        } else {
          this.searchProducts(this.typeSearch)
        }
      } catch (error) {
        this.errorMessage = error.message
        this.openDeleteVariant(variant)
      }
      this.overlay = false
    },
    async forceDeleteProduct () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/catalog/${this.variant._id}?force=true`)
        this.$toasted.show('El producto se eliminó correctamente', { duration: 3000 })
        if (!this.search) {
          await this.load()
        } else {
          this.searchProducts(this.typeSearch)
        }
        this.closeDeleteDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openUploadInvoiceDialog () {
      this.$refs.uploadByXML.open()
    },
    productType (type) {
      return {
        product: 'Producto',
        service: 'Servicio'
      }[type]
    },
    findUnit (id) {
      const unit = this.$store.state.units.find(unitId => unitId._id === id)
      return unit.name
    },
    goToVariantsDuplicates () {
      this.$router.push('/products/variants-duplicates')
    },
    async exportCatalogToCSV () {
      try {
        const params = {
          limit: 0,
          sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
          status: this.statusSelected.value,
          category: this.category.id
        }

        const response = await this.$api.get(`/v1/catalog`, params)
        const table = response.data

        const csvData = await Promise.all(table.map(async (item) => {
          const formattedPresentationQuantity = () => {
            if ((item.displayUnit && item.displayUnit.name) && (item.contentUnit && item.contentUnit.name)) {
              return `${item.contentQuantity} ${item.contentUnit.name} de ${item.displayQuantity} ${item.displayUnit.name}`
            } else {
              return `${item.contentQuantity} ${this.findUnit(item.contentUnit)} de ${item.displayQuantity} ${this.findUnit(item.displayUnit)}`
            }
          }

          return {
            'Clave SAT': item.satCode,
            'Nombre de Producto': item.product.name,
            'Marca': item.brand,
            'Departamento': await (item.product.category ? item.product.category.name : 'Sin departamento'),
            'Cantidad de presentación': formattedPresentationQuantity(),
            'Precio': `$${item.amount}`,
            'Descripción': item.description,
            'Estatus': item.status,
            'Tipo': !item.product ? 'Servicio' : 'Producto'
          }
        }))

        const csv = Papa.unparse(csvData)

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')

        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', `${this.$store.state.currentProvider.data.name}-catalogo.csv`)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$toasted.show('Exportación CSV exitosa', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        } else {
          this.$toasted.show('Exportación CSV no es compatible en este navegador.', { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
    }
  }
}
</script>
